import { render, staticRenderFns } from "./ReleaseBrief.vue?vue&type=template&id=78fe3e50&scoped=true&"
import script from "./ReleaseBrief.vue?vue&type=script&lang=ts&"
export * from "./ReleaseBrief.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseBrief.vue?vue&type=style&index=0&id=78fe3e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe3e50",
  null
  
)

export default component.exports